// extracted by mini-css-extract-plugin
export default {"header":"PL","container":"QL","accordeonitem":"RL","itemsticky":"SL","itemopen":"TL","open":"UL","productname":"VL","productinfo":"WL","flavorstext":"XL","invalidlimit":"YL","limit":"ZL","scrollUpAccordion":"aM","wrapper":"bM"};
    if(module.hot) {
      // 1715632478167
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  